<template>
  <div>
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum Checklist Encontrada"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <!------------- COMEÇO ADICIONAR NOVO CHECKLIST -------------->
              <router-link
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
                to="NovoChecklist"
              >
                <div
                  class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2 text-base text-primary"
                    >Novo Checklist</span
                  >
                </div>
              </router-link>

              <!------------- FINAL ADICIONAR NOVO CHECKLIST ----------------->
            </div>

            <!------------ COMEÇO ITENS POR PAGINA ----------->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ de }} - {{ ate }} de {{ total }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!-------------FINAL ITENS POR PAGINA ------------>
          </div>

          <!------------ COMEÇO TITULO DO CHECKLIST ------------>
          <template slot="thead">
            <vs-th sort-key="responsavel">Responsável</vs-th>
            <vs-th sort-key="dataHora">Data e Hora</vs-th>
            <vs-th sort-key="nome">Nome do Acionante</vs-th>
            <vs-th sort-key="marcaModelo">Marca Modelo</vs-th>
            <vs-th sort-key="motivo">Motivo do Evento</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ FIM DO TITULO DO CHECKLIST ------------>

          <!-- ----------COMEÇO DO CHECKLIST----------- -->
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">{{ tr.responsavel }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.dataHora }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.nome }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.marcaModelo }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.motivo }}</p>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col">
                      <vs-button
                        v-tooltip="'Detalhes do Checklist'"
                        radius
                        color="dark"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-search"
                        class="d-inline"
                        @click="
                          buscarRespostasDoChecklist(tr.idChecklist, tr.motivo)
                        "
                      ></vs-button>
                    </div>
                    <div
                      class="vx-col"
                      v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    >
                      <router-link :to="`EditarChecklist/${tr.idChecklist}`">
                        <vs-button
                          v-tooltip="'Editar o Checklist'"
                          radius
                          color="success"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="d-inline"
                        ></vs-button>
                      </router-link>
                    </div>
                    <div class="vx-col">
                      <router-link
                        target="_blank"
                        :to="`/checklistImpressao/${tr.idChecklist}/${tr.motivo}`"
                      >
                        <vs-button
                          v-tooltip="'Imprimir o Checklist'"
                          radius
                          color="warning"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-printer"
                          class="d-inline"
                        ></vs-button>
                      </router-link>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
          <!-- ----------FIM DO CHECKLIST------------- -->
        </vs-table>
        <vs-pagination
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </div>
    </vx-card>
    <!-- ------------------COMEÇO DADOS DO CHECKLIST--------------------- -->
    <vs-popup
      v-if="popupActive"
      class="holamundo"
      :title="'Detalhes do Checklist'"
      :active.sync="popupActive"
      fullscreen
    >
      <h5 class="my-2" id="checklistTitles">Dados do Checklist</h5>
      <table class="table table-bordered" id="checklistTable">
        <tr>
          <th class="uppercase">Responsável pelo Atendimento</th>
          <td>{{ checklistSelecionado.checklist.responsavel }}</td>
        </tr>
        <tr>
          <th class="uppercase">Data e Hora do Atendimento</th>
          <td>{{ checklistSelecionado.checklist.dataHora }}</td>
        </tr>
        <tr>
          <th class="uppercase">Dia do Atendimento</th>
          <td>{{ checklistSelecionado.checklist.diaSemana }}</td>
        </tr>
        <tr>
          <th class="uppercase">Protocolo WebAssist</th>
          <td>{{ checklistSelecionado.checklist.protocoloWebAssist }}</td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2" id="checklistTitles">Dados do Acionante</h5>
      <table class="table table-bordered" id="checklistTable">
        <tr>
          <th class="uppercase">Tipo do Acionante</th>
          <td>{{ checklistSelecionado.checklist.tipoAcionante }}</td>
        </tr>
        <tr>
          <th class="uppercase">Nome</th>
          <td>{{ checklistSelecionado.checklist.nome }}</td>
        </tr>
        <tr>
          <th class="uppercase">Telefone</th>
          <td>{{ checklistSelecionado.checklist.telefone }}</td>
        </tr>
        <tr>
          <th class="uppercase">Marca/Modelo</th>
          <td>{{ checklistSelecionado.checklist.marcaModelo }}</td>
        </tr>
        <tr>
          <th class="uppercase">Placa</th>
          <td>{{ checklistSelecionado.checklist.placa }}</td>
        </tr>
        <tr>
          <th class="uppercase">Local do Evento</th>
          <td>{{ checklistSelecionado.checklist.localEvento }}</td>
        </tr>
        <tr>
          <th class="uppercase">Motivo do Evento</th>
          <td>{{ checklistSelecionado.checklist.motivo }}</td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2" id="checklistTitles">Dados do Evento</h5>
      <table class="table table-bordered" id="checklistTable">
        <tr
          v-for="(item, index) in checklistSelecionado.respostas"
          :key="index"
        >
          <th class="uppercase">{{ item.pergunta }}</th>
          <td>{{ item.resposta }}</td>
        </tr>
      </table>
    </vs-popup>
    <!-- ------------------FIM DADOS DO CHECKLIST--------------------- -->
  </div>
</template>
<script>
import service from '../../services/index';
import moment from 'moment';
export default {
  props: ['subjectPermission', 'filtros', 'realizarFiltro'],
  data() {
    return {
      selected: [],
      itens: [],
      itemsPerPage: 5,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      popupActive: false,
      checklistSelecionado: {},
      fazerBuscaChecklist: true,
    };
  },
  watch: {
    realizarFiltro: function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.definirPaginaAtualPrimeira();
        this.buscarChecklists();
        this.$emit('finalizarFiltros');
      }
    },
    paginaAtual: function (/*newValue, oldValue*/) {
      this.fazerBuscaChecklist && this.buscarChecklists();
      this.atribirTrueFazerBuscaChecklist();
    },
    itemsPerPage: function (/*newValue, oldValue*/) {
      this.corrigirPaginacao();
      this.buscarChecklists();
    },
  },
  methods: {
    buscarChecklists() {
      this.$vs.loading();
      let objSend = {};
      if (this.filtros) {
        objSend = { ...this.filtros };
        objSend.dataInicial = moment(this.filtros.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtros.dataFinal).format('YYYY-MM-DD');
      } else {
        objSend.dataInicial = moment().add(-30, 'days').format('YYYY-MM-DD');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
      }
      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      service
        .post('Checklist', 'buscarChecklist', objSend)
        .then((res) => {
          this.itens = [];
          this.redefinirPaginacao(res.data);
          this.atribuirChecklists(res.data);
          this.qtdTotal > 0 && this.redefinirPagainaAtual();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    mostrarPop() {
      this.popupActive = !this.popupActive;
    },
    pegarChecklistSelecionado(id_checklist) {
      this.checklistSelecionado.checklist = this.itens.find(
        (a) => a.idChecklist === id_checklist,
      );
    },
    organizarPerguntaseRespostas(data) {
      this.checklistSelecionado.respostas = data
        .map((dados) => {
          return {
            pergunta: dados.Id_Pergunta.pergunta,
            resposta: dados.resposta,
            ordenacao: dados.Id_Pergunta.ordenacao,
          };
        })
        .sort((a, b) => a.ordenacao - b.ordenacao);
    },
    buscarRespostasDoChecklist(id_checklist, motivo) {
      this.$vs.loading();
      service
        .post('Checklist', 'buscarRespostasChecklist', { id_checklist, motivo })
        .then((res) => {
          this.pegarChecklistSelecionado(id_checklist);
          this.organizarPerguntaseRespostas(res.data);
          this.$vs.loading.close();
          this.mostrarPop();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    atribuirChecklists(data) {
      if (this.qtdTotal > 0) {
        data.resultado.forEach((checklist) => {
          checklist.dataHora = moment(checklist.dataHora)
            .utc()
            .format('DD/MM/YYYY HH:mm');
          this.itens.push(checklist);
        });
      }
    },
    redefinirPaginacao(data) {
      this.qtdTotal = data.qtdTotal;
      this.qtdPaginas = data.qtdTotal / this.itemsPerPage;
      if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
      this.qtdPaginas = parseInt(this.qtdPaginas);
    },
    corrigirPaginacao() {
      if ((this.paginaAtual - 1) * this.itemsPerPage > this.total) {
        this.fazerBuscaChecklist = false;
        this.paginaAtual = Math.ceil(this.qtdTotal / this.itemsPerPage);
      }
    },
    redefinirPagainaAtual() {
      if (this.paginaAtual > this.qtdPaginas) {
        this.fazerBuscaChecklist = false;
        this.paginaAtual = this.qtdPaginas;
      }
    },
    definirPaginaAtualPrimeira() {
      if (this.paginaAtual !== 1) {
        this.fazerBuscaChecklist = false;
        this.paginaAtual = 1;
      }
    },
    atribirTrueFazerBuscaChecklist() {
      this.fazerBuscaChecklist = true;
    },
  },

  created() {
    this.buscarChecklists();
  },
  mounted() {},
  computed: {
    de() {
      return this.paginaAtual * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    ate() {
      return (
        this.paginaAtual * this.itemsPerPage -
        this.itemsPerPage +
        this.itens.length
      );
    },
    total() {
      return this.qtdTotal;
    },
  },
};
</script>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
</style>
<style scoped>
#checklistTitles {
  background-color: rgb(248, 248, 248);
  font-size: 1.6em;
  padding: 0.3em 0 0.3em 0;
}

#checklistTable {
  width: 100%;
}

#checklistTable tr {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
<!------------ END STYLE ------------>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
